module.exports = __webpack_public_path__ + "name=img/src/assets/story/6.jpg?26f48a89583af3e03e922b9ec9508963";